// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectBlacklistPageLoading,
  selectBlacklistShowInitWaitingMessage,
  selectBlacklistsInStore,
} from '../_selectors/blacklist.selectors';

export class BlacklistDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectBlacklistPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectBlacklistShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectBlacklistsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
